const getItemOptions = (basketData, itemId) => {
  const selectedItem =
    (basketData &&
      basketData.items &&
      basketData.items.length &&
      basketData.items.find(item => item.id === itemId)) ||
    null;
  if (selectedItem) {
    if (selectedItem.options.length || selectedItem.note) {
      const valueNames = optionsValuesName(selectedItem.options);
      if (selectedItem.note) {
        valueNames.push(`'${selectedItem.note}'`);
      }
      return (valueNames.length && valueNames.join(", ")) || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

//flat henüz tüm browserlarda çalışmıyor, kenimiz tanımlıyoruz
Object.defineProperty(Array.prototype, "flat", {
  value: function(depth = 1) {
    return this.reduce(function(flat, toFlatten) {
      return flat.concat(
        Array.isArray(toFlatten) && depth > 1
          ? toFlatten.flat(depth - 1)
          : toFlatten
      );
    }, []);
  }
});

const optionsValuesName = options => {
  const values = options.map(
    option =>
      (option.values.length && option.values.map(value => value.name)) || []
  );
  const flattedNames = (values.length && values.flat()) || [];
  return flattedNames;
};

export default getItemOptions;
